<template>
  <div id="app">
    <div id="headercontainer">
      <header>
        <h1>🌱 Vegan tooted 🌱</h1>
        <p>
          Tooted tulevad siia
          <a href="https://instagram.com/ohseevegan" target="_blank"
            >@ohseevegan</a
          >
          Instagrami kontolt iga natukese aja tagant. Näita talle Instagramis
          armastust! 💚
        </p>
        <p>
          Kui leiad, et mõni toode siin tabelis ei vasta postitusele, mõnda
          toodet siia ei ilmu või tahad jagada tagasisidet selle lehe kohta,
          kirjuta mulle meiliaadressile
          <a href="mailto:hello@andri.io"
            >he&#108;l&#111;&zwnj;&#64;&zwnj;a&zwnj;&#110;dr&#105;&#46;io</a
          >.
        </p>
        <p>
          Selle rakenduse lähtekood on kättesaadaval
          <a href="https://gitlab.com/hookey/vegan-tooted" target="_blank"
            >GitLabis</a
          >.
        </p>
        <button id="dark-mode-button" @click="toggleDarkMode">
          {{ darkModeEnabled ? "🌞" : "🌛" }}
        </button>
      </header>
    </div>
    <Table :products="products" />
  </div>
</template>

<script>
import Table from "@/components/Table.vue";
import {
  enable as enableDarkMode,
  disable as disableDarkMode,
  isEnabled as isDarkReaderEnabled,
} from "darkreader";

export default {
  name: "App",
  components: {
    Table,
  },
  data() {
    return {
      products: [],
      darkModeEnabled: isDarkReaderEnabled(),
    };
  },
  methods: {
    async getProducts() {
      const res = await fetch(process.env.VUE_APP_API_URL + "get_products");
      // const res = await fetch("http://127.0.0.1:5000/get_products");
      const data = await res.json();
      return data;
    },
    toggleDarkMode() {
      if (this.darkModeEnabled) {
        disableDarkMode();
        this.darkModeEnabled = false;
      } else {
        enableDarkMode();
        this.darkModeEnabled = true;
      }
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  async created() {
    // await this.delay(1337);
    this.products = await this.getProducts();
  },
};
</script>

<style lang="scss">
body {
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
  color: #37474f;
  text-align: center;
}
#headercontainer {
  width: 32rem;
  margin: auto;
}
header {
  padding: 1rem;
  & h1 {
    white-space: nowrap;
  }
}
#dark-mode-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 3rem;
  cursor: pointer;
  border: none;
  background-color: transparent;
  transition: font-size 0.2s ease;
}
#dark-mode-button:hover {
  font-size: 3.5rem;
}
.vgt-table th.descriptionth {
  min-width: 16rem !important;
}
.vgt-table tr:hover {
  background-color: #f2f4f7;
}
.vgt-table th.sortable button {
  cursor: pointer;
}
// .vgt-table td {
//   white-space: pre-wrap;
// }
a {
  cursor: pointer;
  color: #03a9f4;
  text-decoration: none;
}
a:hover {
  color: #0288d1;
  text-decoration: underline;
}
@media screen and (max-width: 48rem) {
  body {
    margin: 0;
  }
  #headercontainer {
    width: 100%;
  }
  header {
    font-size: 0.9rem;
    & h1 {
      font-size: 1.3rem;
    }
  }
  .vgt-table td,
  .vgt-table th {
    font-size: 0.9rem;
  }
  .vgt-wrap__footer {
    display: flex;
    flex-direction: column;
    font-size: 0.9rem !important;
  }
  .footer__navigation {
    display: flex;
    justify-content: center;
    margin-top: 1.5rem;
  }
  .vgt-wrap__footer .footer__navigation__page-info,
  .vgt-wrap__footer .footer__navigation__page-btn {
    margin: 0 !important;
  }
  .vgt-wrap__footer .footer__navigation__page-info {
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .vgt-wrap__footer .footer__row-count {
    display: flex;
    justify-content: center;
  }
  .vgt-wrap__footer .footer__row-count::after {
    position: relative;
    margin-top: 0.6rem;
  }
}
@media screen and (max-width: 32rem) {
  .vgt-table td,
  .vgt-table th {
    font-size: 0.8rem;
  }
}
</style>
